<template>
  <div
    class="gift-card"
    :style="{
      backgroundImage: 'url(' + image + ')',
    }"
  >
    <div class="g-card">
      <img
        :src="require('@/assets/images/dashboard/winona-card.png')"
        width="524"
        height="290"
        alt=""
      />
    </div>
    <div class="gift-content p-5">
      <div>
        <img
          :src="require('@/assets/images/dashboard/hand-heart.svg')"
          width="50"
          height="62"
          alt=""
          class="mb-4"
        />
        <h4
          class="heading text-center"
          style="font-weight: initial; line-height: 1.1"
        >
          Get yourself or your friend a Gift Card!
        </h4>
        <p class="text-center py-2">
          Imperdiet mattis feugiat eget quam mi eget amet, feugiat cras. Varius
          a volutpat maecenas fames tortor auctor blandit lectus nulla sed nisl
          placerat.
        </p>

        <b-button variant="info" size="lg" pill @click="show = true" block>
          Purchase
        </b-button>
      </div>
    </div>

    <b-modal
      ref="gift-modal"
      v-model="show"
      hide-footer
      hide-header
      size="lg"
      centered
    >
      <b-row>
        <b-col cols="12" md="7" align-self="center">
          <img
            :src="require('@/assets/images/dashboard/winona-card.png')"
            width="524"
            height="290"
            style="width: 100%"
            alt=""
          />
        </b-col>
        <b-col cols="12" md="5" class="py-5">
          <b-button
            size="sm"
            variant="link"
            @click="hideModal"
            class="float-right relative"
            style="margin-top: -30px"
          >
            <b-icon icon="x-circle" variant="primary"></b-icon>
          </b-button>
          <h3
            style="font-size: 32px; line-height: 48px; letter-spacing: -0.02em"
          >
            Winona Gift Card
          </h3>
          <p>valid for 6 months</p>
          <p
            class="text-primary"
            style="font-size: 24px; line-height: 36px; letter-spacing: 0.02em"
          >
            $50 | $100 | $250 | $500
          </p>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selected"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="giftcard"
              button-variant="secondary"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <b-button variant="primary" size="lg" pill @click="show = true" block>
            Purchase
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      selected: null,
      options: [
        { text: "$50", value: 50 },
        { text: "$100", value: 100 },
        { text: "$250", value: 250 },
        { text: "$500", value: 500 },
      ],
    };
  },

  methods: {
    hideModal() {
      this.$refs["gift-modal"].hide();
    },
  },
};
</script>

<style>
.custom-control-label::before,
.custom-control-label::after {
  top: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #1a6a72 !important;
  background-color: #1a6a72 !important;
}

.custom-control-label span {
  margin-left: 8px;
}
</style>

<style lang="scss" scoped>
.gift-card {
  display: flex;
  justify-content: space-between;
  width: 95%;
  background-size: contain;
  height: 400px;

  .g-card {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.gift-content {
  display: flex;
  align-items: center;
  position: relative;
  right: -5%;
  top: 10%;
  width: 400px;
  background-color: #f2ffea;

  h4 {
    font-size: 28px;
    letter-spacing: -0.02em;
    line-height: 35px;
  }
}
</style>
